var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4711 4.4714C12.7314 4.21105 12.7314 3.78894 12.4711 3.52859C12.2107 3.26824 11.7886 3.26824 11.5283 3.52859L7.99967 7.05719L4.47108 3.52859C4.21073 3.26824 3.78862 3.26824 3.52827 3.52859C3.26792 3.78894 3.26792 4.21105 3.52827 4.4714L7.05687 8L3.52827 11.5286C3.26792 11.7889 3.26792 12.2111 3.52827 12.4714C3.78862 12.7317 4.21073 12.7317 4.47108 12.4714L7.99967 8.9428L11.5283 12.4714C11.7886 12.7317 12.2107 12.7317 12.4711 12.4714C12.7314 12.2111 12.7314 11.7889 12.4711 11.5286L8.94248 8L12.4711 4.4714Z",
    fill: "#FB7B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBtnIcon);
export default __webpack_public_path__ + "static/media/cross-btn-icon.4156b42c81a860cb2e2aa4f2791242d7.svg";
export { ForwardRef as ReactComponent };